
export const TEXT_FORM = `
...on textForm_Entry {
  id
  typeHandle

  blockId

  backgroundColor
  heading {
    html
  }
  description
  
  formSettings {
    ... on formSettings_ContentBlock {
      heading
      formId
      redirectLocation {
        url
      }
      withBorder
      onlyBusinessEmail
      errorValidateBusinessEmail
    }
  }

}
`